import { motion } from "framer-motion";
import { BadgeCheck, Truck, Clock } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { reveal } from "@/hooks/reveal";

const ICONS = [BadgeCheck, Truck, Clock];

export const TrustBar = () => {
  const { t } = useLang();
  return (
    <section className="relative bg-black/50 border-y border-white/10" data-testid="trust-bar">
      <motion.div
        {...reveal()}
        className="max-w-[1500px] mx-auto px-6 md:px-10 py-6 md:py-7 flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-0"
      >
        {t.trustBar.map((label, i) => {
          const Icon = ICONS[i];
          return (
            <div key={label} className="flex items-center">
              {i > 0 && (
                <span className="hidden sm:block mx-8 md:mx-14 w-1 h-1 rotate-45 bg-[var(--al-gold)]/70" aria-hidden="true" />
              )}
              <div className="flex items-center gap-3 group" data-testid={`trust-bar-item-${i}`}>
                <Icon className="w-4 h-4 text-[var(--al-gold)] transition-transform duration-300 group-hover:scale-110" />
                <span className="font-mono-tech text-[11px] md:text-[12px] tracking-[0.25em] uppercase text-white/70">
                  {label}
                </span>
              </div>
            </div>
          );
        })}
      </motion.div>
    </section>
  );
};
